import { defaultPageData } from '@/utils/constants.js';
import { deepCopy } from '@/utils/index';
export default function (handlePageChange) {
  var pageData = deepCopy(defaultPageData);
  // 处理分页逻辑
  function handleSizeChange(size) {
    pageData.limit = size;
    handlePageChange();
  }
  function handleCurrentChange(page) {
    pageData.page = page;
    handlePageChange();
  }
  function resetPageData() {
    pageData.page = 1;
    pageData.limit = 20;
    handlePageChange();
  }
  return {
    pageData: pageData,
    handleSizeChange: handleSizeChange,
    handleCurrentChange: handleCurrentChange,
    resetPageData: resetPageData
  };
}